module.exports = __webpack_public_path__ + "static/media/sara.e1128d83.jpg";